// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VuePhotoSwipe from './vue-photoswipe'

// All our global styles get added here.
import './assets/style/global.scss'

Vue.config.productionTip = false
Vue.use(VuePhotoSwipe)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js